function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classnames from "classnames";
import { useEffect, useMemo, useRef, useState } from "react";
import { StyledParallaxVideoAssetComponent } from "./parallax-video-asset-component.scss";
import { generateCloudinaryVideoUrl } from "services/community/cloudinary-service";
import FullParagraph from "../../../core-components/full-paragraph/full-paragraph";
import AssetComponent from "components/core/asset/asset-component";
const DEFAULT_PARAGRAPH = {
    topic: {}
};
const COLOUDINERY_FIRST_FRAME_FORMAT = "so_0";
const IMAGE_EXTENSION = "jpg";
const getFirstFrameImage = (videoSrc)=>{
    if (!videoSrc) return null;
    const videoUrl = videoSrc.formats[0];
    const firstFrameFormat = videoUrl.replace(/\/upload\//, `/upload/${COLOUDINERY_FIRST_FRAME_FORMAT}/`);
    return firstFrameFormat.replace(/(\.[\w\d_-]+)$/i, `.${IMAGE_EXTENSION}`);
};
const DEFAULT_VIDEO_CONFIG = {
    autoPlay: true,
    hideControls: true
};
const ParallaxVideoAssetComponent = ({ asset, rightColumn, leftColumn, fullParagraph, marginBetweenSections, marginBetweenColumns, scrollThreshold, fullParagraphAdvancedConfig, columnMarginRight, columnMarginLeft, videoBrightness })=>{
    const videoRef = useRef(null);
    const [isDarkModVideo, setIsDarkModVideo] = useState(false);
    useEffect(()=>{
        const handleScroll = ()=>{
            var _videoRef_current;
            setIsDarkModVideo(((_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.getBoundingClientRect().top) <= 0);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    return /*#__PURE__*/ _jsxs(StyledParallaxVideoAssetComponent, {
        columnMarginRight: columnMarginRight,
        columnMarginLeft: columnMarginLeft,
        marginBetweenColumns: marginBetweenColumns,
        marginBetweenSections: marginBetweenSections,
        scrollThreshold: scrollThreshold,
        videoBrightness: videoBrightness,
        className: "parllax-video-asset-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: videoRef,
                className: "video-container",
                children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({
                    video: asset
                }, DEFAULT_VIDEO_CONFIG), {
                    poster: getFirstFrameImage(asset === null || asset === void 0 ? void 0 : asset.src),
                    className: classnames({
                        dark: isDarkModVideo
                    })
                }))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-container",
                children: [
                    fullParagraph && /*#__PURE__*/ _jsx("div", {
                        className: "center-paragraph",
                        children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, DEFAULT_PARAGRAPH, fullParagraph, fullParagraphAdvancedConfig))
                    }),
                    fullParagraph ? /*#__PURE__*/ _jsx("div", {
                        className: classnames("column", "left-column"),
                        children: leftColumn === null || leftColumn === void 0 ? void 0 : leftColumn.map((config, index)=>/*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, DEFAULT_PARAGRAPH, config, fullParagraphAdvancedConfig), index))
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            leftColumn && leftColumn.length > 0 && /*#__PURE__*/ _jsx("div", {
                                className: classnames("column", "left-column"),
                                children: leftColumn.map((config, index)=>/*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, DEFAULT_PARAGRAPH, config, fullParagraphAdvancedConfig), index))
                            }),
                            rightColumn && rightColumn.length > 0 && /*#__PURE__*/ _jsx("div", {
                                className: classnames("column", "right-column"),
                                children: rightColumn.map((config, index)=>/*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, DEFAULT_PARAGRAPH, config, fullParagraphAdvancedConfig), index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default ParallaxVideoAssetComponent;
